"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Labeler = void 0;
/**
 * Grid Labeler
 */
class Labeler {
    /**
     * Constructor
     *
     * @param enabled
     *            enabled labeler
     * @param minZoom
     *            minimum zoom
     * @param maxZoom
     *            maximum zoom
     * @param color
     *            label color
     * @param textSize
     *            label text size
     * @param buffer
     *            grid edge buffer (greater than or equal to 0.0 and less than
     *            0.5)
     */
    constructor(enabled, minZoom, maxZoom, color, textSize, buffer) {
        /**
         * Enabled labeler
         */
        this.enabled = false;
        /**
         * Minimum zoom level
         */
        this.minZoom = 0;
        /**
         * Maximum zoom level
         */
        this.maxZoom = undefined;
        /**
         * Label color
         */
        this.color = undefined;
        /**
         * Label text size
         */
        this.textSize = 0;
        /**
         * Grid edge buffer (greater than or equal to 0.0 and less than 0.5)
         */
        this.buffer = 0;
        this.enabled = enabled;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.color = color;
        this.textSize = textSize;
        this.buffer = buffer;
    }
    /**
     * Is the grid enabled
     *
     * @return enabled flag
     */
    isEnabled() {
        return this.enabled;
    }
    /**
     * Set the enabled flag
     *
     * @param enabled
     *            enabled flag
     */
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Get the minimum zoom level
     *
     * @return minimum zoom level
     */
    getMinZoom() {
        return this.minZoom;
    }
    /**
     * Set the minimum zoom level
     *
     * @param minZoom
     *            minimum zoom level
     */
    setMinZoom(minZoom) {
        this.minZoom = minZoom;
    }
    /**
     * Get the maximum zoom level
     *
     * @return maximum zoom level
     */
    getMaxZoom() {
        return this.maxZoom;
    }
    /**
     * Has a maximum zoom level
     *
     * @return true if has a maximum, false if unbounded
     */
    hasMaxZoom() {
        return this.maxZoom !== null && this.maxZoom !== undefined;
    }
    /**
     * Set the maximum zoom level
     *
     * @param maxZoom
     *            maximum zoom level
     */
    setMaxZoom(maxZoom) {
        this.maxZoom = maxZoom;
    }
    /**
     * Is the zoom level within the grid zoom range
     *
     * @param zoom
     *            zoom level
     * @return true if within range
     */
    isWithin(zoom) {
        return zoom >= this.minZoom && (this.maxZoom === undefined || this.maxZoom === null || zoom <= this.maxZoom);
    }
    /**
     * Get the label color
     *
     * @return label color
     */
    getColor() {
        return this.color;
    }
    /**
     * Set the label color
     *
     * @param color
     *            label color
     */
    setColor(color) {
        this.color = color;
    }
    /**
     * Get the label text size
     *
     * @return label text size
     */
    getTextSize() {
        return this.textSize;
    }
    /**
     * Set the label text size
     *
     * @param textSize
     *            label text size
     */
    setTextSize(textSize) {
        this.textSize = textSize;
    }
    /**
     * Get the grid edge buffer
     *
     * @return buffer (greater than or equal to 0.0 and less than 0.5)
     */
    getBuffer() {
        return this.buffer;
    }
    /**
     * Set the grid edge buffer
     *
     * @param buffer
     *            buffer (greater than or equal to 0.0 and less than 0.5)
     */
    setBuffer(buffer) {
        if (buffer < 0.0 || buffer >= 0.5) {
            throw new Error('Grid edge buffer must be >= 0 and < 0.5. buffer: ' + buffer);
        }
        this.buffer = buffer;
    }
}
exports.Labeler = Labeler;
//# sourceMappingURL=Labeler.js.map